import { createContext, useContext } from "react";
import type { AppPlatform } from "../shared/platform.ts";
import type { Kv } from "../shared/kv.ts";
import type { Overview } from "./status.ts";

export interface GuardianCtx {
  platform: AppPlatform;
  kv: Kv;
  overview: Overview;
  reload: () => void;
  /** Bumped by the live socket (and reload): screens that fetch list it as a dependency. */
  version: number;
  signOut: () => Promise<void>;
  /** "guardian_app" in the native shells, "web" on the website. */
  client: "guardian_app" | "web";
}

export const GuardianContext = createContext<GuardianCtx | null>(null);

export function useGuardian(): GuardianCtx {
  const c = useContext(GuardianContext);
  if (!c) throw new Error("useGuardian outside GuardianRoot");
  return c;
}

export const G = "/guardian";
